// Generated from packages/native-bridge/contract.json. Do not edit by hand.

export const bridgeName = "NtfyAndroid";
export const backBridgeName = "NtfyAndroidBack";
export const nativeEventName = "ntfy-native-event";
export const protocolVersion = "1.0.0";

export const command = Object.freeze({
  requestNotificationPermission: "requestNotificationPermission",
  requestBatteryOptimizationExemption: "requestBatteryOptimizationExemption",
  requestExactAlarmPermission: "requestExactAlarmPermission",
  refreshSubscriberService: "refreshSubscriberService",
  openNativeSettings: "openNativeSettings",
  upsertSubscription: "upsertSubscription",
  updateSubscription: "updateSubscription",
  removeSubscription: "removeSubscription",
  syncSubscriptions: "syncSubscriptions",
  upsertUser: "upsertUser",
  removeUser: "removeUser",
  syncUsers: "syncUsers",
  exportNotifications: "exportNotifications",
  markNotificationRead: "markNotificationRead",
  markNotificationSequenceRead: "markNotificationSequenceRead",
  markNotificationsRead: "markNotificationsRead",
  deleteNotification: "deleteNotification",
  deleteNotificationSequence: "deleteNotificationSequence",
  deleteNotifications: "deleteNotifications",
  performUserAction: "performUserAction",
  publish: "publish",
  openExternalUrl: "openExternalUrl",
  setPullRefreshEnabled: "setPullRefreshEnabled",
  openService: "openService",
  geofenceGetStatus: "geofenceGetStatus",
  geofenceRequestPermission: "geofenceRequestPermission",
  geofenceUseCurrentLocation: "geofenceUseCurrentLocation",
  geofenceSetConfig: "geofenceSetConfig",
  geofenceEnable: "geofenceEnable",
  geofenceCheckNow: "geofenceCheckNow",
  geofenceSendTest: "geofenceSendTest",
  assistantGetStatus: "assistantGetStatus",
  assistantOpenSettings: "assistantOpenSettings",
  assistantOpenCaptureSettings: "assistantOpenCaptureSettings",
  assistantOpenAppInfo: "assistantOpenAppInfo",
  setThemeMode: "setThemeMode",
  setSurfaceColor: "setSurfaceColor",
  assistSheetReady: "assistSheetReady",
  assistRunPreset: "assistRunPreset",
  assistClose: "assistClose",
});

export const event = Object.freeze({
  nativeReady: "nativeReady",
  foreground: "foreground",
  permissionsChanged: "permissionsChanged",
  subscriberServiceRefreshed: "subscriberServiceRefreshed",
  subscriptionSynced: "subscriptionSynced",
  subscriptionSyncFailed: "subscriptionSyncFailed",
  subscriptionUpdated: "subscriptionUpdated",
  subscriptionUpdateFailed: "subscriptionUpdateFailed",
  subscriptionRemoved: "subscriptionRemoved",
  subscriptionRemoveFailed: "subscriptionRemoveFailed",
  subscriptionsSynced: "subscriptionsSynced",
  subscriptionsSyncFailed: "subscriptionsSyncFailed",
  userSynced: "userSynced",
  userSyncFailed: "userSyncFailed",
  userRemoved: "userRemoved",
  userRemoveFailed: "userRemoveFailed",
  usersSynced: "usersSynced",
  usersSyncFailed: "usersSyncFailed",
  notificationsExported: "notificationsExported",
  notificationsExportFailed: "notificationsExportFailed",
  notificationRead: "notificationRead",
  notificationReadFailed: "notificationReadFailed",
  notificationSequenceRead: "notificationSequenceRead",
  notificationSequenceReadFailed: "notificationSequenceReadFailed",
  notificationsRead: "notificationsRead",
  notificationsReadFailed: "notificationsReadFailed",
  notificationDeleted: "notificationDeleted",
  notificationDeleteFailed: "notificationDeleteFailed",
  notificationSequenceDeleted: "notificationSequenceDeleted",
  notificationSequenceDeleteFailed: "notificationSequenceDeleteFailed",
  notificationsDeleted: "notificationsDeleted",
  notificationsDeleteFailed: "notificationsDeleteFailed",
  userActionQueued: "userActionQueued",
  userActionFailed: "userActionFailed",
  publishSucceeded: "publishSucceeded",
  publishFailed: "publishFailed",
  geofenceStatus: "geofenceStatus",
  geofenceCurrentLocation: "geofenceCurrentLocation",
  geofenceCheckResult: "geofenceCheckResult",
  geofenceError: "geofenceError",
  assistantStatus: "assistantStatus",
  assistSheetState: "assistSheetState",
});
